import { Component, ElementRef, Inject, Input, Optional, Renderer2, SkipSelf, TemplateRef, ViewChild } from "@angular/core";
import { NzMenuGroupComponent } from "ng-zorro-antd/menu";
import { UiIsMenuInsideDropDownToken } from "../../utils/menu.utils";

/**
 * This component extends the base Button directive of NG-Zorro
 * Example usage : https://ng.ant.design/components/button/en
 *
 *
 * Example usage of ui-menu-group
 * <li ui-menu-group menuGroupTitle="SubTitle" nzIcon="appstore"></li>
 *
 * <li ui-menu-group><span title><ui-icon nzType="appstore"></ui-icon><span>SubTitle</span></span></li>
 *
 * <li ui-menu-group [menuGroupTitle]="titleTpl"></li>
 * <ng-template #titleTpl><ui-icon nzType="appstore"></ui-icon><span>SubTitle</span></ng-template>
 *
 *
 * @param menuGroupTitle menuGroupTitle?: string | TemplateRef<void>;
 *
 */

export function MenuGroupFactory(isMenuInsideDropDownToken): boolean {
  return isMenuInsideDropDownToken ? isMenuInsideDropDownToken : false;
}

@Component({
  selector: "[ui-menu-group]",
  exportAs: "uiMenuGroup",
  templateUrl: "./menu-group.component.html",
  providers: [
    /** check if menu inside dropdown-menu component **/
    {
      provide: UiIsMenuInsideDropDownToken,
      useFactory: MenuGroupFactory,
      deps: [[new SkipSelf(), new Optional(), UiIsMenuInsideDropDownToken]],
    },
  ],
})
export class UiMenuGroupComponent extends NzMenuGroupComponent {
  @Input("uiTitle") public nzTitle: string | TemplateRef<void>;
  @ViewChild("titleElement") public titleElement?: ElementRef;

  public constructor(elementRef: ElementRef, uiRenderer: Renderer2, @Inject(UiIsMenuInsideDropDownToken) public isMenuInsideDropDown: boolean) {
    super(elementRef, uiRenderer, isMenuInsideDropDown);
  }
}
